<!-- Start Main Banner Area -->
<div class="hero-banner banner-bg1">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <!--
                        <div class="hero-banner-content">
                            <span class="sub-title">Amazingly Simple</span>
                            <h1>Most Advanced Cross Channel Marketing Platform</h1>
                            <p>Engage your targets across Email , SMS , Mobile Push, Social and Direct Mail..</p>

                            <div class="btn-box">
                                <a href="#" class="default-btn">Get Started <span></span></a>
                            </div>
                        </div>
                        -->
            <div class="hero-banner-content">
              <span class="sub-title">Amazingly Simple</span>
              <!--<h1>Most Advanced Cross Channel Marketing Platform</h1> -->
              <h1>Most Advanced Customer Growth Platform</h1>
              <p>
                Revitalize your outreach with Enaiko's advanced conversational
                and data AI platform, transforming standard interactions into
                personalized, engaging experiences.
              </p>

              <div class="btn-box">
                <!--  <a href="#" class="default-btn">Get Started <span></span></a> -->
                <a class="default-btn">Launching Soon <span></span></a>
              </div>
              <!--
                                <form class="newsletter-form" data-toggle="validator">
                                <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL" required
                                    autocomplete="off">
            
                                <button type="submit">Sign up</button>
                                <div id="validator-newsletter" class="form-result"></div>
                            </form>
                           --->
              <form
                class="newsletter-form"
                (ngSubmit)="sendEmail()"
                #newsletterForm="ngForm"
              >
                <input
                  type="email"
                  class="input-newsletter"
                  placeholder="Enter your email"
                  name="EMAIL"
                  [(ngModel)]="email"
                  #emailField="ngModel"
                  required
                  email
                />

                <!---
                                <div *ngIf="emailField.errors?.required" class="error-c" style=" color: red;margin-top: 20px">
                                    Email is required.
                                  </div> -->
                <div
                  *ngIf="emailField.errors?.email && emailField.touched"
                  class="error-c"
                  style="color: red; margin-top: 20px"
                >
                  Please enter a valid email address.
                </div>

                <button type="submit" [disabled]="!newsletterForm.valid">
                  Sign up
                </button>
                <!-- <button type="submit" [disabled]="emailField.valid">Sign up</button> -->
              </form>

              <div *ngIf="message" class="form-result" style="margin-top: 20px">
                {{ message }}
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="hero-banner-image">
              <img
                src="assets/img/banner-image/marketing platform v2.png"
                alt="image"
              />

              <!--
                            <img src="assets/img/banner-image/1.png" class="wow fadeInDown" data-wow-delay=".9s"
                                alt="image">
                            <img src="assets/img/banner-image/2.png" class="wow fadeInDown" data-wow-delay=".6s"
                                alt="image"> 
                                
                                    <div class="solution-video">
                                        <a href="https://player.vimeo.com/video/403150808?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" class="video-btn popup-youtube"><i
                                                class="flaticon-play-button"></i></a>
                                                
                                    </div>
                                 -->
              <div
                class="solution-video"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  z-index: 10;
                "
              >
                <a
                  href="https://vimeo.com/1013908810?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  class="video-btn popup-youtube"
                  style="
                    font-size: 50px;
                    color: white;
                    background-color: #0000ff;
                    padding: 20px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <i
                    class="flaticon-play-button"
                    style="color: rgb(255, 255, 255)"
                  ></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--
    <div class="shape-img1"><img src="assets/img/shape/1.png" class="wow fadeInUp" data-wow-delay=".9s" alt="image">
    </div>
    
    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
    
    <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/6.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/9.png" alt="image"></div>
    
    <div class="shape-img10"><img src="assets/img/shape/10.png" alt="image"></div>
    -->
</div>
<!-- End Main Banner Area -->

<!-- Start Featured Services Area -->
<section class="featured-services-area ptb-100">
  <div class="container">
    <div class="section-title">
      <span class="sub-title">Our Services</span>
      <h2>Supercharged Engine for Digital Transformation with AI</h2>
    </div>

    <div class="row">
      <div class="col-lg-4 col-sm-6 col-md-6">
        <div class="single-featured-box">
          <div class="icon">
            <i class="flaticon-digital-marketing"></i>
          </div>
          <h3>Cross-channel Conversations</h3>
          <p>
            Engage across channels and convert one-way communications into
            contextual two-way conversations using GenAI.
          </p>

          <a href="/service-details" class="default-btn"
            >Read More <span></span
          ></a>
        </div>
      </div>

      <div
        class="col-lg-4 col-sm-6 col-md-6 offset-lg-0 offset-md-3 offset-sm-3"
      >
        <div class="single-featured-box">
          <div class="icon color-1ac0c6">
            <i class="flaticon-research"></i>
          </div>

          <h3>Live Agent Support</h3>
          <p>
            Establish departments of live agents and enable collaborative live
            agent support enhanced by AI-driven summarization.
          </p>

          <a href="service-details" class="default-btn"
            >Read More <span></span
          ></a>
        </div>
      </div>

      <div class="col-lg-4 col-sm-6 col-md-6">
        <div class="single-featured-box">
          <div class="icon color-facd60">
            <i class="flaticon-analytics"></i>
          </div>

          <h3>Marketing and Conversational Analysis</h3>
          <p>
            Measure communication engagement, analyze current trends, and
            predict future patterns using advanced AI features.
          </p>

          <a href="service-details" class="default-btn"
            >Read More <span></span
          ></a>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Featured Services Area -->

<!-- Start About Area -->
<section class="about-area ptb-100 pt-0">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="about-image">
          <img src="assets/img/allinone.png" alt="image" />
        </div>
      </div>

      <div class="col-lg-6 col-md-12">
        <div class="about-content">
          <span class="sub-title">About Us</span>

          <h2>Transforming Your Digital Journey</h2>
          <p>
            Enaiko democratizes digital prowess, equipping businesses of all
            sizes with tools once exclusive to industry giants. Our mission is
            to make competing on a global scale both achievable and enjoyable
            for small and medium-sized enterprises.
          </p>

          <ul class="features-list">
            <li>
              <span
                ><i class="fas fa-check"></i> Execute campaigns across channels
                with appropriate consents.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Convert these touchpoints into
                two-way conversations.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Use AI agents with appropriate
                guardrails and facilitate natural conversations.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Engage with offers at the most
                opportune moments in your conversations.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Leverage data from the platform to
                provide personalized answers to customer inquiries.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Live agent support with
                AI-generated conversation summaries before handoff.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Amazing insights into
                communication effectiveness.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Embedded CRM - get great insights
                into each recipient interaction.</span
              >
            </li>
            <li>
              <span
                ><i class="fas fa-check"></i> Inject chatbots at the right
                moments in your digital journey.</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image" /></div>
  <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image" /></div>
</section>
<!-- End About Area -->

<!-- Start Services Area 
<section class="services-area ptb-100 bg-F4F7FC">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">What We Do</span>
            <h2>Provide Awesome Service With Our Tools</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-digital-marketing"></i>
                    </div>

                    <h3><a href="#">Create Segments</a></h3>

                    <p>Import Files to populate your recipients. Random Lists to send emails out.Integrate with your CRM systems</p>
                    <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon bg-00aeff">
                        <i class="flaticon-research"></i>
                    </div>

                    <h3><a href="#">Create Great Content</a></h3>

                    <p>Create banners, videos for ads and social marketing per content strategy. Create PDF's for B2B Lead generation</p>
                    <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon bg-f78acb">
                        <i class="flaticon-analytics"></i>
                    </div>

                    <h3><a href="#">Cross Channel</a></h3>

                    <p>Engage across email, sms, mobile push, Direct mail .Budget and publish ads in google, FB,instagram and Linkedin</p>
                    <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon bg-cdf1d8">
                        <i class="flaticon-analysis"></i>
                    </div>

                    <h3><a href="#">Website Tracking</a></h3>

                    <p>Use Google tag manager to add Enaiko targeting to your website. Track what your customers do in your sites.</p>
                    <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon bg-c679e3">
                        <i class="flaticon-mail"></i>
                    </div>

                    <h3><a href="#">Reports and Dashboards</a></h3>

                    <p>Measure your marketing campaigns effectivenes. Monitor revenue and budget spends.</p>
                    <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon bg-eb6b3d">
                        <i class="flaticon-seo"></i>
                    </div>

                    <h3><a href="#">Embedded Compliance</a></h3>

                    <p>Compliant to GDPR , CCPA and Privacy Policies. Provides BCC functionality to archive email and SMS communications.</p>
                    <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>
-->
<!-- End Services Area -->

<!-- Start Why Choose Us Area 
<section class="why-choose-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="why-choose-content">
                    <span class="sub-title">Why Choose Us</span>
                    <h2>See how Enaiko can help you succeed</h2>
                    <p>We believe brand interaction is key in communication. Real innovations and a positive customer
                        experience are the heart of successful communication.</p>

                    <div class="features-text">
                        <h4><i class="flaticon-tick"></i> Small business advice and perspective</h4>
                        <p>Free business strategy and marketing strategy educational videos and webinars.</p>
                    </div>

                    <div class="features-text">
                        <h4><i class="flaticon-tick"></i>One to One customer Success Engineer</h4>
                        <p>Hand hold you to get over the initial hick ups. AI based marketing advisor providing marketing ideas based
                            on your data and market trends.</p> 
                    </div> 
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="why-choose-image">
                    <img src="assets/img/why-choose-img1.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>
-->
<!-- End Why Choose Us Area -->

<!-- Start Fun Facts Area 
<section class="fun-facts-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="324">00</span><span class="sign-icon">+</span></h3>
                    <p>Project Completed</p>
                    <div class="back-text">P</div>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="100">00</span><span class="sign-icon">%</span></h3>
                    <p>Client Satisfaction</p>
                    <div class="back-text">C</div>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="13">00</span></h3>
                    <p>Awards</p>
                    <div class="back-text">A</div>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="48">00</span><span class="sign-icon">+</span></h3>
                    <p>Expert Members</p>
                    <div class="back-text">E</div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- End Fun Facts Area -->

<!-- Start Projects Area 
<section class="projects-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Project Gallery</span>
            <h2>We’ve Done Lot’s Of Work, Let’s Check Some From Here</h2>
        </div>
    </div>

    <div class="container-fluid">
        <div class="projects-slides owl-carousel owl-theme">
            <div class="single-projects-box">
                <img src="assets/img/projects-image/1.jpg" alt="image">

                <div class="projects-content">
                    <h3><a href="#">Digital Marketing</a></h3>
                    <span class="category">Design</span>
                </div>

                <div class="plus-icon">
                    <a href="assets/img/projects-image/1.jpg" class="popup-btn">
                        <span></span>
                    </a>
                </div>
            </div>

            <div class="single-projects-box">
                <img src="assets/img/projects-image/2.jpg" alt="image">

                <div class="projects-content">
                    <h3><a href="#">Design & Development</a></h3>
                    <span class="category">Planing</span>
                </div>

                <div class="plus-icon">
                    <a href="assets/img/projects-image/2.jpg" class="popup-btn">
                        <span></span>
                    </a>
                </div>
            </div>

            <div class="single-projects-box">
                <img src="assets/img/projects-image/3.jpg" alt="image">

                <div class="projects-content">
                    <h3><a href="#">Strategic Planing</a></h3>
                    <span class="category">Marketing</span>
                </div>

                <div class="plus-icon">
                    <a href="assets/img/projects-image/3.jpg" class="popup-btn">
                        <span></span>
                    </a>
                </div>
            </div>

            <div class="single-projects-box">
                <img src="assets/img/projects-image/4.jpg" alt="image">

                <div class="projects-content">
                    <h3><a href="#">SEO Consultancy</a></h3>
                    <span class="category">Development</span>
                </div>

                <div class="plus-icon">
                    <a href="assets/img/projects-image/4.jpg" class="popup-btn">
                        <span></span>
                    </a>
                </div>
            </div>

            <div class="single-projects-box">
                <img src="assets/img/projects-image/5.jpg" alt="image">

                <div class="projects-content">
                    <h3><a href="#">Competitor Analysis</a></h3>
                    <span class="category">Design</span>
                </div>

                <div class="plus-icon">
                    <a href="assets/img/projects-image/5.jpg" class="popup-btn">
                        <span></span>
                    </a>
                </div>
            </div>

            <div class="single-projects-box">
                <img src="assets/img/projects-image/6.jpg" alt="image">

                <div class="projects-content">
                    <h3><a href="#">Social Media Marketing</a></h3>
                    <span class="category">Development</span>
                </div>

                <div class="plus-icon">
                    <a href="assets/img/projects-image/6.jpg" class="popup-btn">
                        <span></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>   -->
<!-- End Projects Area -->

<!-- Start Features Area 
<section class="features-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Our Features</span>
            <h2>We always try to understand customers expectation</h2>
        </div>

        <div class="tab features-list-tab">
            <ul class="tabs">
                <li><a href="#" class="bg-fa7070">
                        <i class="flaticon-achievement"></i>
                        <span>User Experience</span>
                    </a></li>

                <li><a href="#" class="bg-00aeff">
                        <i class="flaticon-architecture"></i>
                        <span>Product Design</span>
                    </a></li>

                <li><a href="#" class="bg-c679e3">
                        <i class="flaticon-digital-marketing"></i>
                        <span>Digital Marketing</span>
                    </a></li>

                <li><a href="#" class="bg-eb6b3d">
                        <i class="flaticon-analytics"></i>
                        <span>Branding</span>
                    </a></li>

                <li><a href="#">
                        <i class="flaticon-data"></i>
                        <span>Development</span>
                    </a></li>

                <li><a href="#" class="bg-f78acb">
                        <i class="flaticon-research"></i>
                        <span>Marketing</span>
                    </a></li>
            </ul>

            <div class="tab_content">
                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title">Define Your Choices</span>
                                <h2>User Experience</h2>
                                <p>We believe brand interaction is key in communication. Real innovations and a positive
                                    customer experience are the heart of successful communication. No fake products and
                                    services. The customer is king, their lives and needs are the inspiration.</p>

                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i> Open Source</span></li>
                                    <li><span><i class="flaticon-tick"></i> Optimal Choice</span></li>
                                    <li><span><i class="flaticon-tick"></i> High Security</span></li>
                                    <li><span><i class="flaticon-tick"></i> Great Advices</span></li>
                                    <li><span><i class="flaticon-tick"></i> Creative Layout</span></li>
                                    <li><span><i class="flaticon-tick"></i> Super Responsive</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/features-image/1.png" alt="image">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/features-image/2.png" alt="image">
                            </div>
                        </div>

                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title">Define Your Choices</span>
                                <h2>Product Design</h2>
                                <p>We believe brand interaction is key in communication. Real innovations and a positive
                                    customer experience are the heart of successful communication. No fake products and
                                    services. The customer is king, their lives and needs are the inspiration.</p>

                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i> Open Source</span></li>
                                    <li><span><i class="flaticon-tick"></i> Optimal Choice</span></li>
                                    <li><span><i class="flaticon-tick"></i> High Security</span></li>
                                    <li><span><i class="flaticon-tick"></i> Great Advices</span></li>
                                    <li><span><i class="flaticon-tick"></i> Creative Layout</span></li>
                                    <li><span><i class="flaticon-tick"></i> Super Responsive</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title">Define Your Choices</span>
                                <h2>Digital Marketing</h2>
                                <p>We believe brand interaction is key in communication. Real innovations and a positive
                                    customer experience are the heart of successful communication. No fake products and
                                    services. The customer is king, their lives and needs are the inspiration.</p>

                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i> Open Source</span></li>
                                    <li><span><i class="flaticon-tick"></i> Optimal Choice</span></li>
                                    <li><span><i class="flaticon-tick"></i> High Security</span></li>
                                    <li><span><i class="flaticon-tick"></i> Great Advices</span></li>
                                    <li><span><i class="flaticon-tick"></i> Creative Layout</span></li>
                                    <li><span><i class="flaticon-tick"></i> Super Responsive</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/features-image/3.png" alt="image">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/features-image/4.png" alt="image">
                            </div>
                        </div>

                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title">Define Your Choices</span>
                                <h2>Branding</h2>
                                <p>We believe brand interaction is key in communication. Real innovations and a positive
                                    customer experience are the heart of successful communication. No fake products and
                                    services. The customer is king, their lives and needs are the inspiration.</p>

                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i> Open Source</span></li>
                                    <li><span><i class="flaticon-tick"></i> Optimal Choice</span></li>
                                    <li><span><i class="flaticon-tick"></i> High Security</span></li>
                                    <li><span><i class="flaticon-tick"></i> Great Advices</span></li>
                                    <li><span><i class="flaticon-tick"></i> Creative Layout</span></li>
                                    <li><span><i class="flaticon-tick"></i> Super Responsive</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title">Define Your Choices</span>
                                <h2>Development</h2>
                                <p>We believe brand interaction is key in communication. Real innovations and a positive
                                    customer experience are the heart of successful communication. No fake products and
                                    services. The customer is king, their lives and needs are the inspiration.</p>

                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i> Open Source</span></li>
                                    <li><span><i class="flaticon-tick"></i> Optimal Choice</span></li>
                                    <li><span><i class="flaticon-tick"></i> High Security</span></li>
                                    <li><span><i class="flaticon-tick"></i> Great Advices</span></li>
                                    <li><span><i class="flaticon-tick"></i> Creative Layout</span></li>
                                    <li><span><i class="flaticon-tick"></i> Super Responsive</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/features-image/5.png" alt="image">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/features-image/6.png" alt="image">
                            </div>
                        </div>

                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title">Define Your Choices</span>
                                <h2>Marketing</h2>
                                <p>We believe brand interaction is key in communication. Real innovations and a positive
                                    customer experience are the heart of successful communication. No fake products and
                                    services. The customer is king, their lives and needs are the inspiration.</p>

                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i> Open Source</span></li>
                                    <li><span><i class="flaticon-tick"></i> Optimal Choice</span></li>
                                    <li><span><i class="flaticon-tick"></i> High Security</span></li>
                                    <li><span><i class="flaticon-tick"></i> Great Advices</span></li>
                                    <li><span><i class="flaticon-tick"></i> Creative Layout</span></li>
                                    <li><span><i class="flaticon-tick"></i> Super Responsive</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img7"><img src="assets/img/shape/7.png" alt="image"></div>
    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image"></div>
</section>  -->
<!-- End Features Area -->

<!-- Start Team Area 
<section class="team-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Our Team</span>
            <h2>Meet Our Awesome Team Member</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/1.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>John Smith</h3>
                        <span>Web Developer</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/2.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>Lucy Eva</h3>
                        <span>Manager</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/3.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>Steven Smith</h3>
                        <span>Web Developer</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/6.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/10.png" alt="image"></div>
</section>  -->
<!-- End Team Area -->

<!-- Start Solution Area -->
<section
  class="solution-area ptb-100 extra-pb jarallax"
  data-jarallax='{"speed": 0.3}'
>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="solution-content">
          <span class="sub-title">Your Gateway to Digital Excellence</span>
          <h2>Grow, engage and thrive with Enaiko's AI-driven platform.</h2>
          <p>
            A graduated strategy designed to guide businesses at different
            stages of maturity through digital advancement, enabling them to
            provide exceptional customer experiences.
          </p>

          <!--<a href="#" class="default-btn">Contact Us <span></span></a> -->
        </div>
      </div>
      <!--
            <div class="col-lg-6 col-md-12">
                <div class="solution-video">
                    <a href="https://player.vimeo.com/video/403150808?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" class="video-btn popup-youtube"><i
                            class="flaticon-play-button"></i></a>
                            
                </div>
            </div>
        -->
    </div>
  </div>
</section>
<!-- End Solution Area -->

<!-- Start Feedback Area 
<section class="feedback-area ptb-100 bg-color">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Testimonials</span>
            <h2>Interesting Feedback as we build</h2>
        </div>
    </div>

    <div class="feedback-slides owl-carousel owl-theme">
        <div class="single-feedback-item">
            <p>“We believe brand interaction is key in communication. Real innovations and a positive customer
                experience are the heart of successful communication. No fake products and services.”</p>

            <div class="client-info">
                <img src="assets/img/client-image/1.jpg" alt="image">

                <h3>Jason Roy</h3>
                <span>Manager</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“We believe brand interaction is key in communication. Real innovations and a positive customer
                experience are the heart of successful communication. No fake products and services.”</p>

            <div class="client-info">
                <img src="assets/img/client-image/2.jpg" alt="image">

                <h3>James Anderson</h3>
                <span>Web Developer</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“We believe brand interaction is key in communication. Real innovations and a positive customer
                experience are the heart of successful communication. No fake products and services.”</p>

            <div class="client-info">
                <img src="assets/img/client-image/3.jpg" alt="image">

                <h3>Sarah Taylor</h3>
                <span>Designer</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“We believe brand interaction is key in communication. Real innovations and a positive customer
                experience are the heart of successful communication. No fake products and services.”</p>

            <div class="client-info">
                <img src="assets/img/client-image/4.jpg" alt="image">

                <h3>Steven Smith</h3>
                <span>Manager</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“We believe brand interaction is key in communication. Real innovations and a positive customer
                experience are the heart of successful communication. No fake products and services.”</p>

            <div class="client-info">
                <img src="assets/img/client-image/5.jpg" alt="image">

                <h3>Tom Nessham</h3>
                <span>EnvyTheme</span>
            </div>
        </div>
    </div>
</section>
-->
<!-- End Feedback Area -->

<!-- Start Pricing Area 
<section class="pricing-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Pricing Plan</span>
            <h2>Choose Your Best Plan</h2>
            <p>Real innovations and a positive customer experience are the heart of successful communication. No fake
                products and services.</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-pricing-box">
                    <div class="pricing-header">
                        <h3>Basic</h3>
                    </div>

                    <div class="price">
                        <sub>$</sub>
                        39.99
                        <sub>/mo</sub>
                    </div>

                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Projects</li>
                        <li><i class="flaticon-tick"></i> Email Support</li>
                        <li><i class="flaticon-tick"></i> Phone Support</li>
                        <li><i class="flaticon-tick"></i> Article Promotion</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-close"></i> Profile Management</li>
                        <li><i class="flaticon-close"></i> Selection Support</li>
                    </ul>

                    <a href="#" class="get-started-btn">Get Started</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-pricing-box red">
                    <div class="pricing-header">
                        <h3>Starter</h3>
                    </div>

                    <div class="price">
                        <sub>$</sub>
                        49.99
                        <sub>/mo</sub>
                    </div>

                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 2 Projects</li>
                        <li><i class="flaticon-tick"></i> Email Support</li>
                        <li><i class="flaticon-tick"></i> Phone Support</li>
                        <li><i class="flaticon-tick"></i> Article Promotion</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-tick"></i> Profile Management</li>
                        <li><i class="flaticon-close"></i> Selection Support</li>
                    </ul>

                    <a href="#" class="get-started-btn">Get Started</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-pricing-box orange">
                    <div class="pricing-header">
                        <h3>Extended</h3>
                    </div>

                    <div class="price">
                        <sub>$</sub>
                        59.99
                        <sub>/mo</sub>
                    </div>

                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 3 Projects</li>
                        <li><i class="flaticon-tick"></i> Email Support</li>
                        <li><i class="flaticon-tick"></i> Phone Support</li>
                        <li><i class="flaticon-tick"></i> Article Promotion</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-tick"></i> Profile Management</li>
                        <li><i class="flaticon-tick"></i> Selection Support</li>
                    </ul>

                    <a href="#" class="get-started-btn">Get Started</a>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/6.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/10.png" alt="image"></div>
</section>
-->
<!-- End Pricing Area -->

<!-- Start Partner Area 
<section class="partner-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Partner</span>
            <h2>We partner with companies of all sizes, all around the world</h2>
        </div>

        <div class="row align-items-center">
            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/1.png" alt="image">
                    <img src="assets/img/partner-image/1.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/2.png" alt="image">
                    <img src="assets/img/partner-image/2.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/3.png" alt="image">
                    <img src="assets/img/partner-image/3.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/4.png" alt="image">
                    <img src="assets/img/partner-image/4.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/5.png" alt="image">
                    <img src="assets/img/partner-image/5.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/6.png" alt="image">
                    <img src="assets/img/partner-image/6.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/7.png" alt="image">
                    <img src="assets/img/partner-image/7.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/8.png" alt="image">
                    <img src="assets/img/partner-image/8.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/9.png" alt="image">
                    <img src="assets/img/partner-image/9.png" alt="image">
                </a>
            </div>

            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/10.png" alt="image">
                    <img src="assets/img/partner-image/10.png" alt="image">
                </a>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/5.png" alt="image"></div>
</section>
-->
<!-- End Partner Area -->

<!-- Start Blog Area
<section class="blog-area ptb-100 bg-F4F7FC">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Latest News</span>
            <h2>Our Latest Articles And News For Our Clients</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a href="#"><img src="assets/img/blog-image/1.jpg" alt="image"></a>
                    </div>

                    <div class="post-content">
                        <div class="post-meta">
                            <ul>
                                <li>By: <a href="#">Sarah Taylor</a></li>
                                <li>June 24, 2019</li>
                            </ul>
                        </div>

                        <h3><a href="#">How To Boost Your Digital Marketing Agency</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>

                        <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a href="#"><img src="assets/img/blog-image/2.jpg" alt="image"></a>
                    </div>

                    <div class="post-content">
                        <div class="post-meta">
                            <ul>
                                <li>By: <a href="#">James Anderson</a></li>
                                <li>June 26, 2019</li>
                            </ul>
                        </div>

                        <h3><a href="#">The Rise Of Smarketing And Why You Need It</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>

                        <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a href="#"><img src="assets/img/blog-image/3.jpg" alt="image"></a>
                    </div>

                    <div class="post-content">
                        <div class="post-meta">
                            <ul>
                                <li>By: <a href="#">Steven Smith</a></li>
                                <li>June 25, 2019</li>
                            </ul>
                        </div>

                        <h3><a href="#">How To Use Music To Boost Your Business</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>

                        <a href="#" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
</section>
 -->
<!-- End Blog Area -->

<!-- Start Subscribe Area 
<section class="subscribe-area ptb-100 pt-0 bg-F4F7FC">
    <div class="container">
        <div class="subscribe-inner-area jarallax" data-jarallax='{"speed": 0.3}'>
            <div class="subscribe-content">
                <span class="sub-title">Get Started Instantly!</span>
                <h2>Get only new update from this newsletter</h2>

                <form class="newsletter-form" data-toggle="validator">
                    <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL" required
                        autocomplete="off">

                    <button type="submit">Subscribe</button>
                    <div id="validator-newsletter" class="form-result"></div>
                </form>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/6.png" alt="image"></div>
</section>
-->
<!-- End Subscribe Area -->
